import { ErpCustomer, Staff } from './erp'

export type QrResponse = {
  customer?: ErpCustomer
  staff?: Staff
  existing_customer_id?: string
}

export type QrResultCustomer = {
  type: 'customer'
  code: string
  pname?: string
}

export type QrResultStaff = {
  type: 'staff'
  code: string
}

export type QrResult = QrResultCustomer | QrResultStaff
